var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index container"},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view',{on:{"showParent":_vm.showParentPage}})],1),(_vm.showParentPage)?_c('div',[_vm._v(" List of QR code types here.... ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }